import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";


export const CertificateNotes = tgxApi.injectEndpoints({

    endpoints: (build) => ({
        
        getCertificateNotesByReferenceId: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-certificate-notes/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['certificateNotesByReferenceId'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateCertificateNoteOrder: build.mutation({
            query: ({ listIds, relationalId, type }) => {
                return {
                    url: `/ajax/update-certificate-note-order/${relationalId}/${type}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: listIds
                };
            },
            invalidatesTags: ['certificateNotesByReferenceId'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", " Notes Order");
            },
        }),

        updateCertificateNote: build.mutation({
            query: ({ noteId, obj }) => {
                return {
                    url: `/ajax/updateCertificateNote/${noteId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: obj
                };
            },
            invalidatesTags: ["certificateNotesByReferenceId",'subDivisionNotesServiceById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Certificate Notes");
            },
        }),

        createCertificateNote: build.mutation({
            query: (obj) => {
                return {
                    url: `/ajax/create-certificate-note`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: obj
                };
            },
            invalidatesTags: ["certificateNotesByReferenceId",'subDivisionNotesServiceById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", " Notes");
            },
        }),

        deleteCertificateNoteById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/deleteCertificateNote/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['certificateNotesByReferenceId'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Certificate Notes");
            },
        }),


    }),
});


export const {
    useGetCertificateNotesByReferenceIdQuery,
    useUpdateCertificateNoteMutation,
    useDeleteCertificateNoteByIdMutation,
    useCreateCertificateNoteMutation,
    useUpdateCertificateNoteOrderMutation,
} = CertificateNotes;